import * as preact from 'preact';
import { ToolWrapper, Error, Loading, getBaseUrl } from './tools-common';
import { useFetch } from '../utils/async';

export function StreamsTool({ active }) {
	let dataUrl = `${getBaseUrl()}/wp-json/site-data/sidebar/streams/`;
	let headers = { Accept: 'application/json' };
	let { data, error, isLoading } = useFetch(dataUrl, { headers });

	let menu_items = data?.stream_tool?.menu_items || [];

	return (
		<ToolWrapper active={active} heading="Video and Live Streams List">
			<a
				className="btn btn--xs btn--full tools-nav__viewall"
				href="https://www.stolaf.edu/multimedia/"
			>
				View All Streams →
			</a>

			{isLoading ? (
				<Loading />
			) : error ? (
				<Error error={error} />
			) : menu_items.length ? (
				<ul className="tools-nav__stream-list">
					{menu_items.map(stream => (
						<li
							className="tools-nav__stream-item u-clearfix"
							role="presentation"
						>
							<StreamsLink stream={stream} />
						</li>
					))}
				</ul>
			) : null}
		</ToolWrapper>
	);
}

function StreamsLink({ stream }) {
	return (
		<a
			className="tools-nav__stream-link tools-nav--focusable"
			target="_blank" // eslint-disable-line react/jsx-no-target-blank
			rel="noopener"
			href={stream.player}
		>
			<figure className="tools-nav__stream-thumbnail">
				<i className="wp-embed-lazy__icon icon icon-play" />
				<img src={stream.thumb} alt={stream.title} />
			</figure>

			<div className="tools-nav__stream-content">
				<span
					className="tools-nav__stream-cat"
					style={{
						backgroundColor: stream.category_color || null,
						color: stream.category_textcolor || null,
					}}
				>
					{stream.category}
				</span>

				<h5
					className="tools-nav__stream-title"
					dangerouslySetInnerHTML={{ __html: stream.hptitle }}
				/>

				<span className="tools-nav__stream-date">{stream.date}</span>
			</div>
		</a>
	);
}
